import React, { useEffect } from "react";
import IndustrialDesignImg from '../Images/IndustrialDesign.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function IndustrialDesign() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={IndustrialDesignImg} alt="Engineering" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Industrial Design</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Industrial Design at Architetive Designs
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        The practice has never drawn a distinction between architecture and industrial design. The point of contact, the thing that you touch, is as important as the broader vision. The industrial design team established in 1980, has developed a wide range of products from door handles to wind turbines; from a fountain pen to the cabin of an executive jet; from a tap to the fit-out of an ocean yacht. Frequently, products are designed in response to a particular project, but we also work directly with clients on product commissions or with companies to develop new products for commercial manufacture.
                    </p>
                </div>
                <div className="flex flex-row gap-4">
                    <Link to='/people'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">People</button>
                    </Link>
                    <Link to='/contact'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Contact</button>
                    </Link>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default IndustrialDesign;